import { Domain as ProductDomain } from "../Product";
import { Domain as AccountDomain } from "../Account";
import { Domain as CloudDomain } from "../Cloud";
import { Domain as SmartCBDomain } from "../SmartCB";
import { Domain as SmartPanelDomain } from "../SmartPanel";
import { Domain as SmartPlugDomain } from "../SmartPlug";

export namespace Domain {
  export type IEnergyStorageSystem = CloudDomain.IEnergyStorageSystem;
  export type SmartCBRealTimeInfo = SmartCBDomain.IRealTimeInfo;
  export enum ResultCode {
    FTK_OK = 0x0000,
    FTK_NG = 0x0001,
    FTK_ACCOUNT_LOGINFAILED = 0x00a0,
    FTK_ACCOUNT_FREEZED = 0x00a1,
    FTK_ACCOUNT_BANED = 0x00a2,
    FTK_ACCOUNT_DISABLED = 0x00a3,
    FTK_ACCOUNT_EMAIL_NOTFOUND = 0x00a4,
    FTK_ACCOUNT_EMAIL_FORMATERROR = 0x00a5,
    FTK_ACCOUNT_EMAIL_EXISTED = 0x00a6,
    FTK_ACCOUNT_UNAUTHORIZED_PERMISSION = 0x00a7,
    FTK_PRODUCT_AUTHORIZED = 0x00b0,
    FTK_PRODUCT_UNAUTHORIZED = 0x00b1,
    FTK_PRODUCT_SAME_HASH = 0x00b2,
    FTK_PRODUCT_SERIALNO_EXISTED = 0x00b3
  }
  export interface IResult {
    status: ResultCode;
    message: string;
    data: any;
  }

  export interface IAccount extends AccountDomain.IAccount {
    web_isediting?: boolean;
  }
  export interface IAccountLoginLog extends AccountDomain.IAccountLoginLog {}
  export interface IAccountWebsideOperationLog
    extends AccountDomain.IAccountWebsideOperationLog {}

  export interface ILoginRequest {
    email: string;
    password: string;
    rememberMe: boolean;
  }

  export interface IForgotPassword {
    email: string;
  }

  export interface IChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
  }

  export interface IProduct extends ProductDomain.IProduct {}

  export interface IDataRequest {
    start?: Date;
    end?: Date;
    uuid: string;
    current_pages?: number;
  }

  export interface IRAYRequest {
    gatewayId: string;
    meterId: string;
    start?: Date;
    end?: Date;
  }

  export interface ICBDataRequest {
    Paneluuid: string;
    CBuuid: string;
  }
  export interface IProductAuthRequest {
    serialNO: string;
    hash: string;
  }
  export interface IProductRegisterRequest {
    deviceSerialNO: string;
    serialNO: string;
  }

  export interface ISmartPanelRequest {
    start?: Date;
    end?: Date;
    uuid: string;
    current_pages?: number;
  }
  export interface ISmartPanelStatusResult {
    cbs: ISmartPanelStatusCBResult[];
    plugs: ISmartPanelStatusPlugResult[];
  }
  export type ISmartCBStatusResult = SmartCBDomain.IStatus;
  export type ISmartCBDemandResult = SmartCBDomain.IDemand;
  export type ISmartCBLoadProfileResult = SmartCBDomain.ILoadProfile;
  export type ISmartCBEventResult = SmartCBDomain.IEvent;
  export type ISmartCBConfigResult = SmartCBDomain.IConfig;
  export type ISmartCBConfigMetaDataResult = SmartCBDomain.IConfigMetaData;
  export type ISmartCBConfigMeterResult = SmartCBDomain.IConfigMeter;
  export type ISmartCBConfigModbusResult = SmartCBDomain.IConfigModbus;
  export type ISmartRealTimeInfoResult = SmartCBDomain.IRealTimeInfo;
  export type ISmartCBResult = SmartCBDomain.ISmartCB;
  export type ISmartCBRelayControlResult = SmartCBDomain.IRelayControl;
  export type ISmartCBRelayControlRequest = SmartCBDomain.IRelayControl;
  export type ISmartCBConfigProtection = SmartCBDomain.IConfigProtection;
  export type ISmartCBConfigProtectionRequest = SmartCBDomain.IProtectionSet;
  export type ISmartCBConfigProtectionResult = SmartCBDomain.IProtectionSet;

  export type ISmartPlugStatusResult = SmartPlugDomain.IStatus;
  export type ISmartPlugResult = SmartPlugDomain.ISmartPlug;
  export type ISmartPlugRelayControlResult = SmartPlugDomain.IRelayControl;
  export type ISmartPlugMetaDataResult = SmartPlugDomain.IMetaData;
  export type ISmartPlugConfigResult = SmartPlugDomain.IConfig;

  export type ISmartPlugRelayControlRequest = SmartPlugDomain.IRelayControl;

  export interface ISmartPanelStatusCBResult {
    c: ISmartCBConfigResult | undefined;
    v: ISmartRealTimeInfoResult | undefined;
    o: ISmartCBStatusResult | undefined;
  }
  export interface ISmartPanelStatusPlugResult {
    c: ISmartPlugConfigResult | undefined;
    v: ISmartPlugStatusResult | undefined;
  }
  // D:\Git\MSPC_CP\02_CloudServer\02_WebSiteServer\webserver\lib\WebDomain\SmartObjectDomain.ts
  export interface ISmartPanelUsages {
    usage?: ISmartPanelUsageInfo;
    lastusage?: ISmartPanelUsageInfo;
    /**日用電度數總量 */
    dayIcon?: string;
    /**月用電度數總量 */
    monthIcon?: string;
    /**週用電度數總量 */
    weekIcon?: string;
    /**年用電度數總量 */
    yearIcon?: string;
    /**本月電費 */
    monthpriceIcon?: string;
    /**本月排放量 */
    monthCO2Icon?: string;
    taipowerPriceDesc: string;
  }
  export interface ISmartPanelUsageInfo {
    /**日用電度數總量 */
    day: number;
    /**月用電度數總量 */
    month: number;
    /**週用電度數總量 */
    week: number;
    /**年用電度數總量 */
    year: number;
    /**本月電費 */
    monthprice?: number;
    /**本月排放量 */
    monthCO2?: number;
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/lib/Domain/Webside/index.ts